<style lang="sass" scoped>
.wrong
  color: #B00020 !important

input
  padding-left: 0 !important

.disabled_input
  color: rgba(51, 68, 85, 0.45) !important
</style>

<template>
  <div class="contact_container bottom-inOutSpread" :class="{'container_wrong': !rePass, 'contact_container_focus': focus}">
    <slot name="icon"></slot>
    <div class="box">
      <input
        :name="name"
        :maxlength="maxlength"
        :value="value"
        class="input"
        :autocomplete="autocomplete"
        :onkeypress="type ==='number' ? 'return event.keyCode>=48&&event.keyCode<=57' : ''"
        :disabled="disabled"
        :placeholder="placeholder"
        :required="required"
        :class="{'disabled_input': disabled }"
        type="text"
        :inputmode="type === 'number' ? 'numeric' : null"
        @focus="handleFocus"
        @blur="onBlur"
        @input="handleInput"
      />
      <!-- <div class="bar" :style="{ color: color }"></div> -->
      <label
        v-if="enableFloat"
        class="label"
        :class="{ 'push-from-bottom': push_from_bottom || value, 'wrong': !rePass, 'label_focus': focus }"
      >{{ label }}</label>
      <label
        v-else
        class="label"
        :class="{ 'push-from-bottom': true, 'wrong': !rePass }"
      >{{ label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  inject: {
    itemPass: {
      default: {
        pass: true
      }
    }
  },
  name: 'ContactVueMaterialInputBox',
  props: {
    name: {
      type: String
    },
    maxlength: {
      type: String,
      default: '19'
    },
    value: {
      type: [String, Number]
    },
    autocomplete: {
      default: 'off',
      type: String,
    },
    backgroundColor: {
      default: '#FAFAFA',
      type: String,
    },
    color: {
      default: '#2196F3',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    label: {
      default: null,
      type: String,
    },
    placeholder: {
      default: null,
      type: String,
    },
    required: {
      default: false,
      type: Boolean,
    },
    type: {
      default: 'text',
      type: String,
    },
    enableFloat: {
      type: Boolean,
      default: true
    },
    titleWidth: {
      type: String,
    },
    isContact: {
      type: Boolean
    }
  },
  data() {
    return {
      push_from_bottom: false,
      focus: false
    }
  },
  computed: {
    rePass() {
      return this.itemPass.pass
    }
  },
  created() {
    if (this.placeholder) this.push_from_bottom = true
  },
  methods: {
    handleInput(event) {
      this.$emit('input', event.target.value)
    },
    onBlur(event) {
      this.focus = false
      this.$emit('pyBlur', event.target.value)
      if (!this.value && !this.placeholder) this.push_from_bottom = false
    },
    handleFocus(event) {
      this.push_from_bottom = true
      this.focus = true
      this.$emit('focus', event)
    }
  },
}
</script>

<style scoped>
.contact_container {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 54px;
  padding-left: 17px;
  background: #F7F7F7;
  border-radius: 4px 4px 0px 0px;
}
.container_wrong {
  border-bottom: 1px solid #B00020;
}

.bottom-inOutSpread:before,.bottom-inOutSpread:after,.bottom-inOutSpread>.ui-border-element:before,.bottom-inOutSpread>.ui-border-element:after {
    content: '';
    position: absolute;
}
.bottom-inOutSpread:after {
  border-bottom: 2px solid #1FC4BC;
  left: 51%;
  right: 51%;
  bottom: 0px;
  transition-property: all;
  transition-timing-function: cubic-bezier(0, 0.98, 0.51, 0.93);
  transition-duration: 200ms;
  transition-delay: 0s;
}
.contact_container_focus:hover:after {
  left: 0%;
  right: 0%;
}
.contact_container_focus:not(:hover):after {
  border-bottom: 2px solid #94979A;
  transition-delay: 0s
}
.label_focus {
  color: #34C9C2 !important;
}
.input {
  display: block;
  width: 100%;
  height: 22px;
  padding: 10px 15px 10px 5px;
  border: none;
  border-bottom: 2px solid #d4d4d4;
  color: rgba(0, 0, 0, 0.87);
  font-size: 16px;
}

.box {
  position: relative;
  width: 100%;
  padding-top: 16px;
}
.input:focus {
  border-bottom: none;
  outline: none;
}
.bar:before,
.bar:after {
  background-color: currentColor;
  content: '';
  height: 2px;
  position: absolute;
  transition: all ease 0.3s;
  width: 0;
}
.bar:before {
  left: 50%;
}
.bar:after {
  right: 50%;
}
.input:focus ~ .bar:before,
.input:focus ~ .bar:after {
  width: 50%;
}
.label {
  position: absolute;
  bottom: 10px;
  font-size: 13px;
  pointer-events: none;
  color: rgba(0, 0, 0, 0.6);
  transition: all ease 0.3s;
}
.push-from-bottom {
  bottom: 45px;
  font-size: 13px;
}
</style>